import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {toast} from 'react-toastify';
import {CustomizedSwitch, Loader, NotError} from 'components';
import {FindErrorItem, FindLoad, TimeInputMinuteStep, timeInputMinuteStepOptions} from 'utils';
import {httpRequestsOnErrorsActions, systemActions} from "store";

const GET_ACTION = 'GET_COMPANY';
const EDIT_ACTION = 'EDIT_COMPANY';

export const StaffCompliance = () => {
    const dispatch = useDispatch();
    const company = useSelector((state) => state.system.company);
    const loading = FindLoad(GET_ACTION);
    const [skipTbDojCheck, setSkipTbDojCheck] = useState(false);
    const [minuteStep, setMinuteStep] = useState(TimeInputMinuteStep.REGULAR);
    const editError = FindErrorItem(EDIT_ACTION);

    const syncFromCompany = () => {
        setSkipTbDojCheck(!!company?.skipTbDojCheck);
        setMinuteStep(company?.timeInputMinuteStep || TimeInputMinuteStep.REGULAR);
    };

    useEffect(() => {
        if (company) syncFromCompany();
    }, [company]);

    // The switch and buttons flip before the request ends; if it fails, show the saved value again.
    useEffect(() => {
        if (!editError) return;
        syncFromCompany();
        toast(<NotError type={'error'} errMessage={'Could not save the setting. Please try again.'}/>);
        dispatch(httpRequestsOnErrorsActions.removeError(EDIT_ACTION));
    }, [editError]);

    // `mergeLatest`: the saga re-reads the office and sends it with only this change. Spreading this
    // screen's `company` would send an older copy of the office and undo edits made in another tab.
    const handleToggle = () => {
        setSkipTbDojCheck(!skipTbDojCheck);
        dispatch(systemActions.editCompany(company.id, {skipTbDojCheck: !skipTbDojCheck}, {mergeLatest: true}));
    };

    const handleMinuteStep = (step) => {
        if (step === minuteStep) return;
        setMinuteStep(step);
        dispatch(systemActions.editCompany(company.id, {timeInputMinuteStep: step}, {mergeLatest: true}));
    };

    if (loading?.length) {
        return <Loader height={350}/>;
    }

    return (
        <div className="supervision-settings-wrapper">
            <div className="supervision-section">
                <div className="eligibility-auto-box">
                    <div className="eligibility-auto-head" style={{borderBottom: 'none', padding: 0}}>
                        <div>
                            <p className="settings-subsection-title">Skip TB / DOJ Appointment Checks</p>
                            <p className="settings-subsection-desc" style={{margin: 0}}>
                                When enabled, TB and DOJ compliance checks will be skipped when creating appointments.
                            </p>
                        </div>
                        <CustomizedSwitch checkedBgColor={'#0C66E4'} checked={skipTbDojCheck} handleClick={handleToggle}/>
                    </div>
                </div>
            </div>
            <div className="supervision-section" style={{marginTop: 8}}>
                <div className="eligibility-auto-box">
                    <div className="eligibility-auto-head" style={{borderBottom: 'none', padding: 0}}>
                        <div>
                            <p className="settings-subsection-title">Time Input Minute Interval</p>
                            <p className="settings-subsection-desc" style={{margin: 0}}>
                                Minutes offered in every time picker. Regular allows any minute. Other options limit minutes to that interval, e.g. 15 min allows :00, :15, :30 and :45.
                            </p>
                        </div>
                    </div>
                    <div className="settings-segmented" role="radiogroup" aria-label="Time input minute interval">
                        {timeInputMinuteStepOptions.map((option) => (
                            <button
                                key={option.value}
                                type="button"
                                role="radio"
                                aria-checked={minuteStep === option.value}
                                className={minuteStep === option.value ? 'active' : ''}
                                onClick={() => handleMinuteStep(option.value)}>
                                {option.label}
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};
